import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Formulaire } from '@mozaic-ds/freemarker/js/modules/_forms.js';
import { FocusAdvice } from './lib/focus-advice';
import { getTmsInstance } from 'integration-web-core--socle/js/assets/commons/_tms.js';
import RedirectTemplate from './templates/standardlead/c-redirect.tpl';
import SuccessCustomerTemplate from './templates/standardlead/c-success-customer.tpl';
import SuccessCollaboratorTemplate from './templates/standardlead/c-success-collaborateur.tpl';
import ErrorTemplate from './templates/standardlead/c-error.tpl';
import GenericalLoader from 'integration-web-core--socle/js/assets/modules/_genericalLoader.class.js';
import DatePicker from 'integration-web-core--socle/js/assets/modules/_datePicker.class.js';
import { formatAppointmentHours, formatDate } from './lib/format-date';
import Modal from '@mozaic-ds/freemarker/js/modules/_modal.js';
import DayOff from '../model/dayOff.json';
import { Sanitize } from './lib/sanitize';
import { createSerializeObjectForm } from './lib/utils';
import { PostalCodeAutoComplete } from './lib/postal-code-auto-complete';
import { addTrackingButton } from './lib/buttonsTraking';
var StandardLeadPage = /*#__PURE__*/function (_lm$Composant) {
  function StandardLeadPage(id) {
    var _this;
    _classCallCheck(this, StandardLeadPage);
    _this = _callSuper(this, StandardLeadPage, [id]);
    var zoneIsolation = document.querySelector('.js-header-isolation');
    _this.myComponent = document.querySelector('.component-standardleadpageapp');
    _this.initRedirectAfterSubmit();
    if (zoneIsolation) {
      var offset = zoneIsolation.offsetTop - 128;
      window.scroll(0, offset);
    }
    if (document.querySelector('.js-postal-code-city')) {
      _this.postalCode = new PostalCodeAutoComplete();
      _this.postalCode.initPostalCode();
    }
    if (document.getElementsByName('telephone')) {
      _this.input = new FocusAdvice();
      _this.input.inputPhoneNumberAdvice();
    }
    _this.sanitizer = new Sanitize();
    if (document.querySelector('.js-title')) {
      _this.title = document.querySelector('.js-title').innerHTML;
    }
    _this.form = _this.target.querySelector('.js-form');
    _this.currentStep = _this.target.dataset.step;
    if (_this.target.querySelector('.js-tracking-title')) {
      _this.stepName = _this.target.querySelector('.js-tracking-title').innerHTML;
    }
    _this.featureName = _this.target.dataset.feature;
    _this.trezorElement = document.querySelector('#trezorFormular');
    _this.loginButton = document.querySelector('.js-login-button');
    _this.residenceType = document.querySelector('.js-residence-type');
    _this.disableSubmitButtonFromResidenceType = false;
    _this.houseType = document.querySelector('.js-house-type');
    _this.disableSubmitButtonFromHouseType = false;
    _this.individualStatus = document.querySelector('.js-individual-status');
    _this.disableSubmitButtonFromIndividualStatus = false;
    _this.moreThanTwoYearsHouse = document.querySelector('.js-more-than-two-years-house');
    _this.disableSubmitButtonFromMoreThanTwoYearsHouse = false;
    _this.haveLinky = document.querySelector('.js-have-linky');
    _this.disableSubmitButtonFromHaveLinky = false;
    _this.selectStoreInput = document.querySelector('#storeChoice--982');
    _this.typeOfStoveInput = document.querySelectorAll('.js-type-of-stove');
    _this.pelletStoveSelection = document.querySelector('.js-pellet-stove-selection');
    _this.stoveBrandSelect = document.querySelector('select[name="stoveBrand"]');
    if (_this.typeOfStoveInput && _this.pelletStoveSelection) {
      _this.applyPelletStoveSelectionStyle();
    }
    if (_this.selectStoreInput) {
      _this.addAttributeList();
    }
    if (_this.title) {
      _this.initTitle();
    }
    if (_this.form) {
      _this.initForm();
    }
    if (_this.residenceType) {
      _this.residenceTypeInfoMessage();
    }
    if (_this.houseType) {
      _this.houseTypeInfoMessage();
    }
    if (_this.individualStatus) {
      _this.individualStatusInfoMessage();
    }
    if (_this.moreThanTwoYearsHouse) {
      _this.moreThanTwoYearsHouseInfoMessage();
    }
    if (_this.haveLinky) {
      _this.haveLinkyInfoMessage();
    }
    if (_this.trezorElement) {
      if (_this.trezorElement.dataset.info) {
        _this.dateInfo = _this.trezorElement.dataset.info.split('/');
      }
      if (_this.dateInfo) {
        var leadType = _this.trezorElement.querySelector('input[name="typeLead"]');
        if (leadType.value !== 'COURS_DE_BRICOLAGE') {
          formatAppointmentHours();
        }
        _this.dateInfo[0] = _this.initPremDate(_this.dateInfo[0]);
        _this.dateInfo[1] = _this.initPremDate(_this.dateInfo[1]);
      }
      _this.initializeTrezorFormular();
      _this.trezorUrl = _this.trezorElement.getAttribute('data-url');
    }
    if (_this.loginButton !== undefined && _this.loginButton !== null) {
      _this.loginButton.addEventListener('click', function () {
        _this.goToLoginPage();
      });
    }
    _this.modalButton = document.querySelector('.js-partner-button');
    if (_this.modalButton) {
      _this.modal = new Modal({
        classContent: 'js-partner-modal'
      });
      _this.modalButtonFirstCta = document.querySelector('.js-partner-modal .js-modal-first-cta');
      _this.modalButton.addEventListener('click', function (event) {
        event.preventDefault();
        _this.modal.open();
      });
      _this.modalButtonFirstCta.addEventListener('click', function (event) {
        event.preventDefault();
        _this.modal.close();
      });
    }
    addTrackingButton(_this.myComponent);

    // get lead from external call (ex: BP CE)
    _this.prescribingAgencyInput = document.querySelector('.prescribing-agency');
    _this.prescribingCompanyInput = document.querySelector('.prescribing-company');
    if (_this.prescribingAgencyInput || _this.prescribingCompanyInput) {
      _this.setLeadFromExternalInput();
    }
    return _this;
  }
  _inherits(StandardLeadPage, _lm$Composant);
  return _createClass(StandardLeadPage, [{
    key: "setLeadFromExternalInput",
    value: function setLeadFromExternalInput() {
      var prescribingAgency = localStorage.getItem('trek:prescribingAgency');
      var prescribingCompany = localStorage.getItem('trek:prescribingCompany');
      if (prescribingAgency) {
        this.prescribingAgencyInput.value = prescribingAgency;
      }
      if (prescribingCompany) {
        this.prescribingCompanyInput.value = prescribingCompany;
      }
    }
  }, {
    key: "applyPelletStoveSelectionStyle",
    value: function applyPelletStoveSelectionStyle() {
      var _this2 = this;
      this.typeOfStoveInput.forEach(function (input) {
        input.addEventListener('change', function () {
          var _this2$stoveBrandSele, _this2$stoveBrandSele2;
          var isPellet = input.value === 'PELLETS';
          _this2.pelletStoveSelection.classList.toggle('hidden', !isPellet);
          _this2.stoveBrandSelect.value = isPellet ? (_this2$stoveBrandSele = _this2.stoveBrandSelect.options[0]) === null || _this2$stoveBrandSele === void 0 ? void 0 : _this2$stoveBrandSele.value : (_this2$stoveBrandSele2 = _this2.stoveBrandSelect.options[1]) === null || _this2$stoveBrandSele2 === void 0 ? void 0 : _this2$stoveBrandSele2.value;
        });
      });
    }
  }, {
    key: "initRedirectAfterSubmit",
    value: function initRedirectAfterSubmit() {
      var scripts = document.querySelectorAll('.js-redirect-after-submit script.redirectAfterSubmit');
      var jsonldData = {};
      scripts.forEach(function (script) {
        var scriptJson = JSON.parse(script.innerHTML);
        jsonldData = _objectSpread(_objectSpread({}, jsonldData), scriptJson);
      });
      if (jsonldData.redirectUrl) {
        this.redirectAfterSubmit = jsonldData.redirectUrl;
      }
    }
  }, {
    key: "addAttributeList",
    value: function addAttributeList() {
      this.selectStoreInput.setAttribute('list', 'storeSelection');
      return this.selectStoreInput;
    }
  }, {
    key: "initPremDate",
    value: function initPremDate(date) {
      var testDate = new Date(date);
      if (this.isOff(testDate)) {
        testDate.setDate(testDate.getDate() + 1);
        return this.initPremDate(formatDate(testDate));
      } else {
        return date;
      }
    }
  }, {
    key: "isOff",
    value: function isOff(date) {
      var forDayOff = formatDate(date);
      // return true to disable weekend and day off
      return date.getDay() === 6 || date.getDay() === 0 || DayOff.includes(forDayOff);
    }
  }, {
    key: "serializeDateFormat",
    value: function serializeDateFormat() {
      var serializeDate = this.datePicker.dateValue.split('/').reverse().join('-');
      this.datePicker.datePicker.element.value = serializeDate;
    }

    /**
     * Initialize title for app
     */
  }, {
    key: "initTitle",
    value: function initTitle() {
      var titleHead = document.createElement('title');
      titleHead.innerHTML = "".concat(this.title.trim(), " | Leroy Merlin");
      document.getElementsByTagName('head')[0].appendChild(titleHead);
    }

    /**
     * Initialize form validation & form submition
     */
  }, {
    key: "initForm",
    value: function initForm() {
      var _this3 = this;
      try {
        new Formulaire(this.form);
      } catch (error) {
        console.error("error ".concat(error));
      }
      if (this.currentStep !== null) {
        this.manageTracking('step.display');
      }
      this.form.addEventListener('submit', function (event) {
        event.preventDefault();
        _this3.manageTracking('step.submit');
        _this3.manageSubmit(event);
      });
    }
  }, {
    key: "manageTracking",
    value: function manageTracking(step) {
      getTmsInstance().pushEvent(document, 'cdl_event', {
        'event_name': "".concat(step),
        'event_data': {
          'feature_name': "".concat(this.featureName),
          'step_name': "".concat(this.stepName),
          'step_number': "".concat(this.currentStep)
        },
        'merge': true
      });
    }

    /**
     * Prepare the submition of the form
     * @param {event} param0 submition event
     */
  }, {
    key: "manageSubmit",
    value: function manageSubmit(_ref) {
      var target = _ref.target;
      target.submit();
    }
  }, {
    key: "initializeTrezorFormular",
    value: function initializeTrezorFormular() {
      var _this4 = this;
      this.trezorForm = new Formulaire(this.trezorElement);
      this.leadType = this.trezorElement.querySelector('input[name="typeLead"]') ? this.sanitizer.escapeHTML(this.trezorElement.querySelector('input[name="typeLead"]').value) : '';
      var leadSubType = this.trezorElement.dataset.leadsubtype;
      if (leadSubType) {
        if (leadSubType === 'POSE_DE_POELE_A_BOIS') {
          this.leadType = 'POSE_DE_POELE_BOIS_PRIME_RENOV';
        }
        if (leadSubType === 'POSE_DE_POELE_A_GRANULES') {
          this.leadType = 'POSE_DE_POELE_A_GRANULES_PRIME_RENOV';
        }
      }
      if (this.dateInfo) {
        this.initializeDatePicker(this.dateInfo[0], this.dateInfo[1]);
      }
      this.trezorElement.addEventListener('submit', function (event) {
        event.preventDefault();
        if (_this4.dateInfo && _this4.dateInfo[2] === 'DESKTOP') {
          _this4.serializeDateFormat();
        }
        var formName = document.querySelector('.js-main-title').innerHTML.trim();
        var btnName = document.querySelector('.js-submit-btn span').innerHTML.trim();
        getTmsInstance().pushEvent(document, 'cdl_event', {
          'event_name': 'button.click',
          'event_data': {
            'button_name': "".concat(btnName),
            'button_type': 'contact',
            'button_value': "".concat(_this4.leadType, " | ").concat(formName)
          }
        });
        _this4.createLead();
      });
      this.changeCheckboxValue();
    }
  }, {
    key: "createLead",
    value: function createLead() {
      var _document$cookie$spli,
        _document$cookie$spli2,
        _this5 = this;
      var DOMElement = document.querySelector('.js-header-isolation').children[0];
      DOMElement.innerHTML = '';
      this.loader = new GenericalLoader();
      var load = document.createElement('div');
      load.classList.add('page-loader');
      this.loader.append(load);
      load.insertAdjacentHTML('beforeend', '<p aria-live="polite">Envoi en cours...</p>');
      this.formZone = document.querySelector('.js-form-zone');
      DOMElement.parentNode.insertAdjacentElement('afterbegin', load);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      var salesConsultantInput = this.formZone.querySelector('input[name="salesConsultant"]');
      var isCollaborator = salesConsultantInput !== null && salesConsultantInput.value !== '';
      var firstnameInput = this.formZone.querySelector('input[name="prenom"]');
      var lastnameInput = this.formZone.querySelector('input[name="nom"]');
      var firstname = firstnameInput ? this.sanitizer.escapeHTML(firstnameInput.value) : '';
      var lastname = lastnameInput ? this.sanitizer.escapeHTML(lastnameInput.value) : '';
      var storeCode = (_document$cookie$spli = (_document$cookie$spli2 = document.cookie.split('; ').find(function (row) {
        return row.startsWith('store_id=');
      })) === null || _document$cookie$spli2 === void 0 ? void 0 : _document$cookie$spli2.split('=')[1]) !== null && _document$cookie$spli !== void 0 ? _document$cookie$spli : '';
      lm.fetch({
        url: this.trezorUrl,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Cache': 'no-cache'
        },
        credentials: 'same-origin',
        body: createSerializeObjectForm(this.formZone),
        success: function success(_success) {
          var json = {};
          json = JSON.parse(_success);
          var appointmentMethod = _this5.sanitizer.escapeHTML(document.querySelector('input[name="appointmentMethod"]').value);
          var type = appointmentMethod ? appointmentMethod : '';
          var isDuplicate = json.status === 998;
          var leadType = _this5.leadType;
          DOMElement.parentNode.removeChild(DOMElement.parentNode.querySelector('.page-loader'));
          _this5.formZone.remove();
          if (isCollaborator) {
            DOMElement.insertAdjacentHTML('beforeend', lm.template(SuccessCollaboratorTemplate, {
              firstname: firstname,
              lastname: lastname,
              leadType: leadType,
              storeCode: storeCode
            }));
          } else if (_this5.redirectAfterSubmit && _this5.redirectAfterSubmit.trim() !== '') {
            var redirectUrl = _this5.appendJwtToUrl(_this5.redirectAfterSubmit, json.leadIdJwt);
            window.open(redirectUrl, '_blank');
            DOMElement.insertAdjacentHTML('beforeend', lm.template(RedirectTemplate, {
              type: type,
              leadType: leadType
            }));
          } else {
            DOMElement.insertAdjacentHTML('beforeend', lm.template(SuccessCustomerTemplate, {
              type: type,
              isDuplicate: isDuplicate,
              leadType: leadType
            }));
          }
        },
        error: function error(_error) {
          DOMElement.parentNode.removeChild(DOMElement.parentNode.querySelector('.page-loader'));
          var json = {};
          try {
            json = JSON.parse(_error);
          } catch (error) {
            console.error("JSON parse error ".concat(error));
            json.message = 'Une erreur est survenue, veuillez réessayer plus tard.<br/>Nous vous prions de bien vouloir nous en excuser.';
          }
          _this5.formZone.remove();
          var leadType = _this5.leadType;
          DOMElement.insertAdjacentHTML('beforeend', lm.template(ErrorTemplate, {
            message: json.message,
            leadType: leadType
          }));
        }
      });
    }
  }, {
    key: "appendJwtToUrl",
    value: function appendJwtToUrl(url, jwt) {
      var normalizedUrl = url.endsWith('/') ? url : "".concat(url, "/");
      if (!jwt) {
        return normalizedUrl;
      }
      return normalizedUrl + jwt;
    }

    /**
     *
     * @param {String} prmMinDate in Date format, ex : 2019-01-01
     * @param {String} prmMaxDate in Date format, ex : 2019-01-01
     */
  }, {
    key: "initializeDatePicker",
    value: function initializeDatePicker(prmMinDate, prmMaxDate) {
      var _this6 = this;
      if (this.dateInfo && this.dateInfo[2] === 'DESKTOP') {
        this.datePicker = new DatePicker({
          element: 'input[name="dateRdv"]',
          dateFormat: 'd/m/Y',
          minDate: new Date(prmMinDate),
          maxDate: new Date(prmMaxDate),
          disableMobile: 'true',
          'disable': [
          //Un array permettant de désactiver certaines dates, une fonction est utilisable, ici on va désactiver la possibilité de choisir les weekends
          function (date) {
            return _this6.isOff(date);
          }]
        });
        this.datePicker.dateValue = prmMinDate;
      } else {
        var dateChangeMobile = function dateChangeMobile(element) {
          var selectedDate = new Date(element.target.value);
          var parent = element.target.closest('.mc-field');
          if (parent.querySelector('.js-form-error')) {
            element.target.classList.remove('is-invalid');
            parent.removeChild(parent.querySelector('.js-form-error'));
          }
          if (_this6.isOff(selectedDate)) {
            element.target.value = '';
            element.target.classList.add('is-invalid');
            var error = /*html*/"\n              <span class=\"mc-field__error-message js-form-error\" id=\"error-off-day\">\n                D\xE9sol\xE9 le jour choisi n'est pas disponible\n              </span>\n        ";
            parent.insertAdjacentHTML('beforeend', error);
          }
        };
        this.datePicker = document.querySelector('input[name="dateRdv"]');
        this.datePicker.min = prmMinDate;
        this.datePicker.max = prmMaxDate;
        this.datePicker.value = prmMinDate;
        this.datePicker.addEventListener('input', dateChangeMobile);
      }
    }
  }, {
    key: "changeCheckboxValue",
    value: function changeCheckboxValue() {
      var checkboxes = this.trezorElement.querySelectorAll('input[type="checkbox"]');
      var _iterator = _createForOfIteratorHelper(checkboxes),
        _step;
      try {
        var _loop = function _loop() {
          var checkbox = _step.value;
          checkbox.addEventListener('change', function () {
            if (checkbox.value === 'false') {
              checkbox.value = 'true';
            } else {
              checkbox.value = 'false';
            }
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "residenceTypeInfoMessage",
    value: function residenceTypeInfoMessage() {
      var _this7 = this;
      var inputs = this.target.querySelectorAll('.js-residence-type');
      var _iterator2 = _createForOfIteratorHelper(inputs),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var input = _step2.value;
          input.addEventListener('change', function (event) {
            if (event.target.value === 'TENANT') {
              _this7.appendResidenceTypeTenantInfoMessage();
            } else {
              _this7.removeResidenceTypeTenantInfoMessage();
            }
            _this7.disableSubmitButton();
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "appendResidenceTypeTenantInfoMessage",
    value: function appendResidenceTypeTenantInfoMessage() {
      this.form.querySelector('.residence-type').insertAdjacentHTML('afterend', "\n      <div class=\"mu-mt-200 residence-type-tenant-info-message\" data-cerberus=\"DIV_residenceTypeTenantInfoMessage\">\n        <div class=\"mc-notification\">\n          <div class=\"mc-notification__content\">\n            <p class=\"mc-notification__message\" data-cerberus=\"P_residenceTypeTenantInfoMessage\">\n              Nous vous conseillons donc de vous rapprocher de votre propri\xE9taire, c\u2019est lui qui pourra monter le dossier du chantier et l\u2019obtention des aides pour le projet.\n            </p>\n          </div>\n        </div>\n      </div>\n    ");
      this.disableSubmitButtonFromResidenceType = true;
    }
  }, {
    key: "removeResidenceTypeTenantInfoMessage",
    value: function removeResidenceTypeTenantInfoMessage() {
      try {
        this.form.querySelector('.residence-type-tenant-info-message').remove();
        this.disableSubmitButtonFromResidenceType = false;
      } catch (error) {
        console.error("error ".concat(error));
      }
    }
  }, {
    key: "houseTypeInfoMessage",
    value: function houseTypeInfoMessage() {
      var _this8 = this;
      var inputs = this.target.querySelectorAll('.js-house-type');
      var _iterator3 = _createForOfIteratorHelper(inputs),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var input = _step3.value;
          input.addEventListener('change', function (event) {
            if (event.target.value === 'APARTMENT') {
              _this8.appendHouseTypeApartmentInfoMessage();
            } else {
              _this8.removeHouseTypeApartmentInfoMessage();
            }
            _this8.disableSubmitButton();
          });
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "appendHouseTypeApartmentInfoMessage",
    value: function appendHouseTypeApartmentInfoMessage() {
      this.form.querySelector('.house-type').insertAdjacentHTML('afterend', "\n      <div class=\"mu-mt-200 house-type-apartment-info-message\" data-cerberus=\"DIV_houseTypeApartmentInfoMessage\">\n        <div class=\"mc-notification\">\n          <div class=\"mc-notification__content\">\n            <p class=\"mc-notification__message\" data-cerberus=\"P_houseTypeApartmentInfoMessage\">\n              <b>Nous attirons votre attention !</b>\n              Nous ne r\xE9alisons pas de projets d'installation dans les appartements. Nous vous invitons \xE0 vous rapprocher de votre copropri\xE9t\xE9 pour poursuivre les d\xE9marches.\n            </p>\n          </div>\n        </div>\n      </div>\n    ");
      this.disableSubmitButtonFromHouseType = true;
    }
  }, {
    key: "removeHouseTypeApartmentInfoMessage",
    value: function removeHouseTypeApartmentInfoMessage() {
      try {
        this.form.querySelector('.house-type-apartment-info-message').remove();
        this.disableSubmitButtonFromHouseType = false;
      } catch (error) {
        console.error("error ".concat(error));
      }
    }
  }, {
    key: "individualStatusInfoMessage",
    value: function individualStatusInfoMessage() {
      var _this9 = this;
      var inputs = this.target.querySelectorAll('.js-individual-status');
      var _iterator4 = _createForOfIteratorHelper(inputs),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var input = _step4.value;
          input.addEventListener('change', function (event) {
            if (event.target.value === 'NO') {
              _this9.appendIndividualStatusNoInfoMessage();
            } else {
              _this9.removeIndividualStatusNoInfoMessage();
            }
            _this9.disableSubmitButton();
          });
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "appendIndividualStatusNoInfoMessage",
    value: function appendIndividualStatusNoInfoMessage() {
      this.form.querySelector('.individual-status').insertAdjacentHTML('afterend', "\n      <div class=\"mu-mt-200 individual-status-no-info-message\" data-cerberus=\"DIV_individualStatusNoInfoMessage\">\n        <div class=\"mc-notification\">\n          <div class=\"mc-notification__content\">\n            <p class=\"mc-notification__message\" data-cerberus=\"P_individualStatusNoInfoMessage\">\n              <b>Nous attirons votre attention !</b>\n              L\u2019offre est r\xE9serv\xE9e aux clients particuliers.\n            </p>\n          </div>\n        </div>\n      </div>\n    ");
      this.disableSubmitButtonFromIndividualStatus = true;
    }
  }, {
    key: "removeIndividualStatusNoInfoMessage",
    value: function removeIndividualStatusNoInfoMessage() {
      try {
        this.form.querySelector('.individual-status-no-info-message').remove();
        this.disableSubmitButtonFromIndividualStatus = false;
      } catch (error) {
        console.error("error ".concat(error));
      }
    }
  }, {
    key: "moreThanTwoYearsHouseInfoMessage",
    value: function moreThanTwoYearsHouseInfoMessage() {
      var _this0 = this;
      var inputs = this.target.querySelectorAll('.js-more-than-two-years-house');
      var _iterator5 = _createForOfIteratorHelper(inputs),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var input = _step5.value;
          input.addEventListener('change', function (event) {
            if (event.target.value === 'NO') {
              _this0.appendMoreThanTwoYearsHouseNoInfoMessage();
            } else {
              _this0.removeMoreThanTwoYearsHouseNoInfoMessage();
            }
            _this0.disableSubmitButton();
          });
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "appendMoreThanTwoYearsHouseNoInfoMessage",
    value: function appendMoreThanTwoYearsHouseNoInfoMessage() {
      this.form.querySelector('.more-than-two-years-house').insertAdjacentHTML('afterend', "\n      <div class=\"mu-mt-200 more-than-two-years-house-no-info-message\" data-cerberus=\"DIV_moreThanTwoYearsHouseNoInfoMessage\">\n        <div class=\"mc-notification\">\n          <div class=\"mc-notification__content\">\n            <p class=\"mc-notification__message\" data-cerberus=\"P_moreThanTwoYearsHouseNoInfoMessage\">\n              <b>Nous attirons votre attention !</b>\n              Notre solution n\u2019est malheureusement pas encore disponible pour vous, mais nous mettons tout en \u0153uvre pour y rem\xE9dier.\n            </p>\n          </div>\n        </div>\n      </div>\n    ");
      this.disableSubmitButtonFromMoreThanTwoYearsHouse = true;
    }
  }, {
    key: "removeMoreThanTwoYearsHouseNoInfoMessage",
    value: function removeMoreThanTwoYearsHouseNoInfoMessage() {
      try {
        this.form.querySelector('.more-than-two-years-house-no-info-message').remove();
        this.disableSubmitButtonFromMoreThanTwoYearsHouse = false;
      } catch (error) {
        console.error("error ".concat(error));
      }
    }
  }, {
    key: "haveLinkyInfoMessage",
    value: function haveLinkyInfoMessage() {
      var _this1 = this;
      var inputs = this.target.querySelectorAll('.js-have-linky');
      var _iterator6 = _createForOfIteratorHelper(inputs),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var input = _step6.value;
          input.addEventListener('change', function (event) {
            if (event.target.value === 'NO') {
              _this1.appendHaveLinkyNoInfoMessage();
            } else {
              _this1.removeHaveLinkyNoInfoMessage();
            }
            _this1.disableSubmitButton();
          });
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "appendHaveLinkyNoInfoMessage",
    value: function appendHaveLinkyNoInfoMessage() {
      this.form.querySelector('.have-linky').insertAdjacentHTML('afterend', "\n      <div class=\"mu-mt-200 have-linky-no-info-message\" data-cerberus=\"DIV_haveLinkyNoInfoMessage\">\n        <div class=\"mc-notification\">\n          <div class=\"mc-notification__content\">\n            <p class=\"mc-notification__message\" data-cerberus=\"P_haveLinkyNoInfoMessage\">\n              <b>Nous attirons votre attention !</b>\n              Notre solution n\u2019est malheureusement pas encore disponible pour vous, mais nous mettons tout en \u0153uvre pour y rem\xE9dier.\n            </p>\n          </div>\n        </div>\n      </div>\n    ");
      this.disableSubmitButtonFromHaveLinky = true;
    }
  }, {
    key: "removeHaveLinkyNoInfoMessage",
    value: function removeHaveLinkyNoInfoMessage() {
      try {
        this.form.querySelector('.have-linky-no-info-message').remove();
        this.disableSubmitButtonFromHaveLinky = false;
      } catch (error) {
        console.error("error ".concat(error));
      }
    }
  }, {
    key: "disableSubmitButton",
    value: function disableSubmitButton() {
      try {
        this.form.querySelector('.submit-button').disabled = this.disableSubmitButtonFromResidenceType || this.disableSubmitButtonFromHouseType || this.disableSubmitButtonFromIndividualStatus || this.disableSubmitButtonFromMoreThanTwoYearsHouse || this.disableSubmitButtonFromHaveLinky;
      } catch (error) {
        console.error("error ".concat(error));
      }
    }
  }, {
    key: "goToLoginPage",
    value: function goToLoginPage() {
      var url = '/servicesleadpage/services/authenticationleadapp';
      var pathname = window.location.pathname;
      var params = [];
      var elements = this.trezorElement.querySelectorAll('input[type="radio"]:checked, input[type="text"], input[type="tel"], input[type="email"], input[type="number"], select, textarea, input[type="checkbox"], input[type="hidden"], input[type="date"]');
      var _iterator7 = _createForOfIteratorHelper(elements),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var element = _step7.value;
          var name = element.name,
            value = element.value;
          if (!name) {
            continue;
          }
          if (value === 'NULL' || value === '' || value === 'false') {
            continue;
          }
          if (name === 'codePostal') {
            name = 'postalCode';
          }
          if (name === 'typeLead') {
            name = 'leadType';
          }
          var encodedName = encodeURIComponent(name);
          var encodedValue = encodeURIComponent(value);
          params.push("__".concat(encodedName, "=").concat(encodedValue));
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      var baseReferer = "".concat(pathname, "/authentication");
      var encodedReferer = encodeURIComponent(baseReferer + params.join(''));
      window.location.href = "".concat(url, "?referer=").concat(encodedReferer);
    }
  }]);
}(lm.Composant);
lm.DOMReady(function () {
  try {
    new StandardLeadPage('standardleadpageapp');
  } catch (error) {
    console.error("error ".concat(error));
  }
});
export default StandardLeadPage;